import styled from 'styled-components'
import { grayLight } from '@bufferapp/ui/style/colors'

import { flexCol } from '~/shared/styles/layout'

/**
 *
 */

export const Wrapper = styled.div`
  ${flexCol}
  width: 514px;
  margin: 16px auto;
  padding: 8px;
  border: 1px solid ${grayLight};
`
